class Overlay {
	create(onDestroyCallback) {
		$(document.body).append('<div class="overlay" onclick="javascript:void(0)"></div>');

		$('.tpl-scroller').addClass('overlayHideScroll');

		$(document.body).on('click', '.overlay', () => {
			$(document.body).off('click', '.overlay');
			this.destroy(onDestroyCallback);
		});
	}

	destroy(onDestroyCallback) {
		$(document.body).removeClass('hasOverlay').css({});
		$('.tpl-scroller').removeClass('overlayHideScroll');

		$('.overlay').remove();
		if(onDestroyCallback) {
			onDestroyCallback();
		}
	}
}

export let overlay = new Overlay();
